const dataBlog = [
    {
        id: 1,
        srcimg: 'images/blog/v1/1.jpg',
        srcimg2: 'images/blog/v2/1.jpg',
        title: 'Responsive layout',
        time: '15 November 2020',
        author: 'By admin',
        category: 'In WordPress',
        comments: '9',
        like: '1',
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into [...]"
    },
    {
        id: 2,
        srcimg: 'images/blog/v1/2.jpg',
        srcimg2: 'images/blog/v2/2.jpg',
        title: 'Heading into Monday',
        time: '15 November 2020',
        author: 'By admin',
        category: 'In WordPress',
        comments: '9',
        like: '1',
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into [...]"
    },
    {
        id: 3,
        srcimg: 'images/blog/v1/3.jpg',
        srcimg2: 'images/blog/v2/3.jpg',
        title: "Let's go",
        time: '15 November 2020',
        author: 'By admin',
        category: 'In WordPress',
        comments: '9',
        like: '1',
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into [...]"
    },
    {
        id: 4,
        srcimg: 'images/blog/v1/4.jpg',
        srcimg2: 'images/blog/v2/4.jpg',
        title: 'Everything is included',
        time: '15 November 2020',
        author: 'By admin',
        category: 'In WordPress',
        comments: '9',
        like: '1',
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into [...]"
    }
    
]
export default dataBlog;